/** Тексты печатных документов (`t("docs.<группа>.…")`): по файлу на группу разделов. */
import * as sales from "./sales";
import * as staff from "./staff";
import * as stock from "./stock";
import * as warehouse from "./warehouse";

export const docsRu = { stock: stock.ru, warehouse: warehouse.ru, staff: staff.ru, sales: sales.ru };
export const docsEn = { stock: stock.en, warehouse: warehouse.en, staff: staff.en, sales: sales.en };
export const docsKy = { stock: stock.ky, warehouse: warehouse.ky, staff: staff.ky, sales: sales.ky };
export const docsUz = { stock: stock.uz, warehouse: warehouse.uz, staff: staff.uz, sales: sales.uz };
